import { create } from "zustand";
import { persist } from "zustand/middleware";

interface LocationStore {
	coordinates?: [number, number];
	setCoordinates: (coordinates: [number, number]) => void;
}

export const useLocationStore = create<LocationStore>()(
	persist(
		(set) => ({
			coordinates: undefined,
			setCoordinates: (coordinates) => set({ coordinates }),
		}),
		{
			name: "location-store",
		},
	),
);
